import type {
  MigrationAnalyticsEvent,
  MigrationFacts,
  MigrationItem,
  MigrationItemAsset,
  MigrationItemDependency,
  MigrationItemEvent,
  RescanResult,
  SystemAgility,
} from '@/api/types/migration'

// ── Migration Tracker scope shape ───────────────────────────────────────────
// What the tracker keeps per org × index in the browser: items, their assets,
// dependencies, events, re-scans and agility, plus the Discovery facts they
// are raised against. The submission plan itself (Part A, annexes, versions,
// the submission record) lives in qtz-readiness; see lib/migration/usePlan.

export interface MigrationScope {
  items: MigrationItem[]
  item_assets: MigrationItemAsset[]
  item_deps: MigrationItemDependency[]
  item_events: MigrationItemEvent[]
  rescans: RescanResult[]
  agility: SystemAgility[]
  analytics: MigrationAnalyticsEvent[]
  facts: MigrationFacts | null
  item_seq: number
  last_sync_at: string | null
  wave_plan_changed_at: string | null
}

export const emptyMigrationScope = (): MigrationScope => ({
  items: [],
  item_assets: [],
  item_deps: [],
  item_events: [],
  rescans: [],
  agility: [],
  analytics: [],
  facts: null,
  item_seq: 0,
  last_sync_at: null,
  wave_plan_changed_at: null,
})

export const itemCode = (n: number) => `MI-${String(n).padStart(3, '0')}`
